/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppCommerceDataSchema } from "@schemas/message/whatsAppCommerceDataSchema";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// refer to WhatsAppResponseMessageCatalogExport
export const whatsAppResponseCatalogMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("catalog"),
  body: z.string().nullable().optional(),
  footer: z.string().nullable().optional(),
  commerce_data: whatsAppCommerceDataSchema,
});
